import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';

import { useParams } from 'react-router-dom';
import { SyncedInfoProvider } from 'common/components/Autosync/SyncedInfoProvider.tsx';
import { EmptyClipboardModal } from 'common/components/EmptyClipboardModal';
import { KFA_LAYOUTS } from '../../../common/components/LayoutsRightPanel/LayoutTab/Layouts';

import {
  RTEContextProvider,
  SectionsProvider,
} from '../../../common/components/SectionLayout/SectionContext';
import insertChartAndTable from '../../../common/helpers/insertMinitableEventListener';

import { initialSections } from '../libraryItemsSupports';
import CreateHypothesis from './CreateHypothesis';

const CreateHypothesisWithSections = () => {
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;

  const [deactivateCallback, setDeactivateCallback] = useState(null);
  const [noDataOnClipboard, setNoDataOnClipboard] = useState(false);
  const darkMode = useSelector((state) => state.userSettings.settings.darkMode);
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const contextStatusInfoItem = { value: 999 };
  const setEventListener = useCallback(
    (editor) => {
      const editorContainer = document.getElementById('rich-text-editor');
      if (deactivateCallback) {
        deactivateCallback();
        setDeactivateCallback(null);
      }
      if (editorContainer && editor) {
        const removeListener = insertChartAndTable({
          contextStatusInfoItem,
          darkMode,
          dispatch,
          editor,
          isPwcUser,
          editorContainer,
          projectId,
          setNoDataOnClipboard,
        });

        setDeactivateCallback(() => {
          return () => {
            removeListener();
          };
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [deactivateCallback, projectId, darkMode, dispatch, isPwcUser]
  );

  return (
    <SectionsProvider
      value={{ initialSections, rightPanelLayoutType: KFA_LAYOUTS }}
    >
      <SyncedInfoProvider value={contextStatusInfoItem}>
        <RTEContextProvider
          value={{
            setEditor: setEventListener,
          }}
        >
          {noDataOnClipboard && (
            <EmptyClipboardModal
              show={noDataOnClipboard}
              onHide={() => setNoDataOnClipboard(false)}
            />
          )}

          <div id="rich-text-editor" />

          <CreateHypothesis dispatch={dispatch} />
        </RTEContextProvider>
      </SyncedInfoProvider>
    </SectionsProvider>
  );
};

export default CreateHypothesisWithSections;
